import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-manufacturer" }
const _hoisted_2 = { class: "flex gap-4" }
const _hoisted_3 = { class: "flex gap-4" }
const _hoisted_4 = { class: "flex gap-4" }

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";

import type {
  ManufacturerType,
  ManufacturerPayloadType,
} from "@/common/types/manufacturer";

import { baseInput, baseSelect, baseTextEditor } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form-manufacturer',
  props: {
    data: {},
    isPatch: { type: Boolean }
  },
  emits: ["update:data", "salve:data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_DATA = {
  owner_id: props.data?.manufacturer_id,
  name: "",
  web_site: "",
  status: "ACTIVE",
  description: "",
  foundation_date: "",
  country_of_origin: "",
  city_of_origin: "",
  closing_date: "",
  fusion_date: "",
  sale_date: "",
};

const payload = ref<ManufacturerPayloadType>({ ...DEFAULT_DATA });

const optionsStatus = computed(() => [
  {
    option: t("common.labels.active"),
    value: "ACTIVE",
  },
  {
    option: t("common.labels.inactive"),
    value: "INACTIVE",
  },
]);

function update(key: keyof typeof payload.value) {
  if (props.isPatch) {
    emit("update:data", { [key]: payload.value[key] });
    return;
  }

  emit("update:data", payload.value);
}

function resumeData() {
  if (!props.data) return;

  const {
    name,
    web_site,
    status,
    description,
    foundation_date,
    country_of_origin,
    city_of_origin,
    closing_date,
    fusion_date,
    sale_date,
  } = props.data;

  payload.value = {
    ...payload.value,
    name,
    web_site,
    status,
    description,
    foundation_date,
    country_of_origin,
    city_of_origin,
    closing_date,
    fusion_date,
    sale_date,
  };
}

const debouceUpdate = debounce(update, 300);

watchEffect(() => {
  resumeData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.name,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (_unref(debouceUpdate)('name')))
      ],
      value: payload.value.name,
      placeholder: _unref(t)('common.placeholders.name'),
      required: ""
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " * ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value", "placeholder"]),
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.web_site,
      "onUpdate:modelValue": [
        _cache[2] || (_cache[2] = ($event: any) => ((payload.value.web_site) = $event)),
        _cache[3] || (_cache[3] = ($event: any) => (_unref(debouceUpdate)('web_site')))
      ],
      value: payload.value.web_site,
      placeholder: "exe: https://www.website.com"
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.web_site")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.country_of_origin,
        "onUpdate:modelValue": [
          _cache[4] || (_cache[4] = ($event: any) => ((payload.value.country_of_origin) = $event)),
          _cache[5] || (_cache[5] = ($event: any) => (_unref(debouceUpdate)('country_of_origin')))
        ],
        value: payload.value.country_of_origin,
        placeholder: _unref(t)('common.placeholders.country_of_origin')
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.country_of_origin")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.city_of_origin,
        "onUpdate:modelValue": [
          _cache[6] || (_cache[6] = ($event: any) => ((payload.value.city_of_origin) = $event)),
          _cache[7] || (_cache[7] = ($event: any) => (_unref(debouceUpdate)('city_of_origin')))
        ],
        value: payload.value.city_of_origin,
        placeholder: _unref(t)('common.placeholders.city_of_origin')
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.city_of_origin")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.foundation_date,
        "onUpdate:modelValue": [
          _cache[8] || (_cache[8] = ($event: any) => ((payload.value.foundation_date) = $event)),
          _cache[9] || (_cache[9] = ($event: any) => (_unref(debouceUpdate)('foundation_date')))
        ],
        value: payload.value.foundation_date,
        placeholder: _unref(t)('common.placeholders.date_example')
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.foundation_date")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.closing_date,
        "onUpdate:modelValue": [
          _cache[10] || (_cache[10] = ($event: any) => ((payload.value.closing_date) = $event)),
          _cache[11] || (_cache[11] = ($event: any) => (_unref(debouceUpdate)('closing_date')))
        ],
        value: payload.value.closing_date,
        placeholder: _unref(t)('common.placeholders.date_example')
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.closing_date")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.fusion_date,
        "onUpdate:modelValue": [
          _cache[12] || (_cache[12] = ($event: any) => ((payload.value.fusion_date) = $event)),
          _cache[13] || (_cache[13] = ($event: any) => (_unref(debouceUpdate)('fusion_date')))
        ],
        value: payload.value.fusion_date,
        placeholder: _unref(t)('common.placeholders.date_example')
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.fusion_date")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.sale_date,
        "onUpdate:modelValue": [
          _cache[14] || (_cache[14] = ($event: any) => ((payload.value.sale_date) = $event)),
          _cache[15] || (_cache[15] = ($event: any) => (_unref(debouceUpdate)('sale_date')))
        ],
        value: payload.value.sale_date,
        placeholder: _unref(t)('common.placeholders.date_example')
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.sale_date")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"])
    ]),
    _createVNode(_unref(baseSelect), {
      modelValue: payload.value.status,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((payload.value.status) = $event)),
      value: payload.value.status,
      options: optionsStatus.value,
      "is-empty": false,
      onChange: _cache[17] || (_cache[17] = ($event: any) => (_unref(debouceUpdate)('status')))
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.status")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value", "options"]),
    _createVNode(_unref(baseTextEditor), {
      modelValue: payload.value.description,
      "onUpdate:modelValue": [
        _cache[18] || (_cache[18] = ($event: any) => ((payload.value.description) = $event)),
        _cache[19] || (_cache[19] = ($event: any) => (_unref(debouceUpdate)('description')))
      ]
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})